import { Instance } from 'mobx-state-tree';
import { ShopifyInstallationDtoModelBase } from './ShopifyInstallationDtoModel.base';

/* The TypeScript type of an instance of ShopifyInstallationDtoModel */
export interface ShopifyInstallationDtoModelType extends Instance<typeof ShopifyInstallationDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyInstallationDtoModel */
export { selectFromShopifyInstallationDto, shopifyInstallationDtoModelPrimitives, ShopifyInstallationDtoModelSelector } from './ShopifyInstallationDtoModel.base';

/**
 * ShopifyInstallationDtoModel
 */
export const ShopifyInstallationDtoModel = ShopifyInstallationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
